import React, { useMemo } from "react"
import { useSnapshot } from "valtio"
import SizeSummary from "./SizeSummary"
import { Steps } from "../../../../constants"
import DesignTypeSummary from "./DesignTypeSummary"
import { Emblem3dSummary } from "./Emblem3dSummary"
import ImageSliderSummary from "./ImageSliderSummary"
import { wizardStore } from "../../../../stores/wizard"
import LeatherEmblemSummary from "./LeatherEmblemSummary"
import RequestDetailsSummary from "./RequestDetailsSummary"
import { ColorSummary, ColorsSummary } from "./ColorSummary"

const SummaryContentComponent = {
  [Steps.Backing]: ImageSliderSummary,
  [Steps.BorderColor]: ColorSummary,
  [Steps.BorderType]: ImageSliderSummary,
  [Steps.DesignType]: DesignTypeSummary,
  [Steps.HolographicUpload]: DesignTypeSummary,
  [Steps.HolographicColors]: ColorsSummary,
  [Steps.FabricColor]: ColorSummary,
  [Steps.FabricType]: ImageSliderSummary,
  [Steps.ProductSubtype]: ImageSliderSummary,
  [Steps.ProductType]: ImageSliderSummary,
  [Steps.GarmentType]: ImageSliderSummary,
  [Steps.Location]: ImageSliderSummary,
  [Steps.Shape]: ImageSliderSummary,
  [Steps.Layout]: ImageSliderSummary,
  [Steps.SizeStandard]: SizeSummary,
  [Steps.ThreadColors]: ColorsSummary,
  [Steps.Emblem3d]: Emblem3dSummary,
  [Steps.EmblemLeather]: LeatherEmblemSummary,
  [Steps.RequestDetails]: RequestDetailsSummary,
}

export default function SummaryContent() {
  const wizSnap = useSnapshot(wizardStore)
  const summaryStepContent = useMemo(() => wizSnap.emblemData[wizSnap.step.id], [wizSnap.emblemData, wizSnap.step.id])
  const SummaryComponent = useMemo(() => SummaryContentComponent[wizSnap.step.id], [wizSnap.step.id])

  return (
    <React.Fragment>
      <div className="relative w-full h-full min-h-64">
        <div className="flex flex-col h-full w-full pt-4">
          {SummaryComponent ? (
            <SummaryComponent content={summaryStepContent} />
          ) : null}
        </div>
      </div>
    </React.Fragment>
  )
}